/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WorkorderQueryFromJSON, WorkorderQueryToJSON, } from './';
export function UserCustomWorkorderFilterFromJSON(json) {
    return UserCustomWorkorderFilterFromJSONTyped(json, false);
}
export function UserCustomWorkorderFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !exists(json, 'title') ? undefined : json['title'],
        'query': !exists(json, 'query') ? undefined : WorkorderQueryFromJSON(json['query']),
        'count': !exists(json, 'count') ? undefined : json['count'],
        'buttonColor': !exists(json, 'buttonColor') ? undefined : json['buttonColor'],
    };
}
export function UserCustomWorkorderFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'query': WorkorderQueryToJSON(value.query),
        'count': value.count,
        'buttonColor': value.buttonColor,
    };
}
